import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';
import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';

import _ from 'lodash';
import { format } from 'date-fns';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import { deleteInvoice, fetchInvoiceList, reissueInvoice, retryPushInvoice } from '@/api/finance/invoice';
import { searchUserList } from '@/api/system/user';
import InvoiceDialog from './invoice-dialog/index.vue';
import { COMPANY_OPTIONS } from './invoice-options';

var INVOICE_STATUS_ALIAS = {
  0: 'unknown',
  1: 'processing',
  2: 'success',
  3: 'failed',
  UNKNOWN: 'unknown',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
  INVOICE_PROCESSING: 'processing',
  INVOICE_SUCCESS: 'success',
  INVOICE_FAILED: 'failed',
  开票中: 'processing',
  已开票: 'success',
  开票成功: 'success',
  开票失败: 'failed'
};

var INVOICE_STATUS_MAP = {
  unknown: { label: '未知', type: 'info' },
  processing: { label: '开票中', type: 'warning' },
  success: { label: '开票成功', type: 'success' },
  failed: { label: '开票失败', type: 'danger' }
};

var MANUAL_INVOICE_STATUS_ALIAS = {
  0: 'unspecified',
  1: 'processing',
  2: 'issued',
  3: 'failed',
  UNSPECIFIED: 'unspecified',
  PROCESSING: 'processing',
  ISSUED: 'issued',
  FAILED: 'failed',
  INVOICE_STATUS_UNSPECIFIED: 'unspecified',
  INVOICE_STATUS_PROCESSING: 'processing',
  INVOICE_STATUS_ISSUED: 'issued',
  INVOICE_STATUS_FAILED: 'failed',
  开票中: 'processing',
  开票完成: 'issued',
  开票失败: 'failed'
};

var MANUAL_INVOICE_STATUS_MAP = {
  unspecified: { label: 'Unspecified', type: 'info' },
  processing: { label: '开票中', type: 'warning' },
  issued: { label: '开票完成', type: 'success' },
  failed: { label: '开票失败', type: 'danger' }
};

var ADVANCE_SYNC_STATUS_ALIAS = {
  0: 'pending',
  1: 'processing',
  2: 'success',
  3: 'failed',
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
  ADVANCE_SYNC_PENDING: 'pending',
  ADVANCE_SYNC_PROCESSING: 'processing',
  ADVANCE_SYNC_SUCCESS: 'success',
  ADVANCE_SYNC_FAILED: 'failed',
  PREPAY_SYNC_PENDING: 'pending',
  PREPAY_SYNC_PROCESSING: 'processing',
  PREPAY_SYNC_SUCCESS: 'success',
  PREPAY_SYNC_FAILED: 'failed',
  待同步: 'pending',
  预收同步中: 'processing',
  预收同步成功: 'success',
  预收同步失败: 'failed'
};

var ADVANCE_SYNC_STATUS_MAP = {
  pending: { label: '待同步', type: 'info' },
  processing: { label: '预收同步中', type: 'warning' },
  success: { label: '预收同步成功', type: 'success' },
  failed: { label: '预收同步失败', type: 'danger' }
};

var HAS_REFUND_OPTIONS = [{ label: '是', value: 1 }, { label: '否', value: 2 }];

var TRAFFIC_TYPE_MAP = {
  MWS_MONTHLY_SPEND: 'MWS-月耗'
};

var RECEIPT_STATUS_MAP = {
  1: '待收款',
  2: '已收款',
  3: '已退款'
};

var COMPANY_SEARCH_OPTIONS = COMPANY_OPTIONS.map(function (item) {
  return {
    label: item.label,
    value: item.code
  };
});

var REMOVED_QUERY_KEYS = ['adv_user', 'is_recharged', 'estimate_company_name'];

var defaultQuery = {
  page: 1,
  page_size: 15,
  advance_id: '',
  customer_name: '',
  adv_id: '',
  estimate_company_code: '',
  manual_invoice_id: '',
  created_by: '',
  has_refund: '',
  start_date: '',
  end_date: '',
  time: []
};

function normalizeStatus(status, aliasMap) {
  if (_.isNil(status) || status === '') return '';
  var rawStatus = String(status).trim();
  return aliasMap[rawStatus] || aliasMap[rawStatus.toUpperCase()] || rawStatus;
}

function formatDateTime(value) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  if (_.isNil(value) || value === '') return '-';
  var numberValue = Number(value);
  var date = _Number$isNaN(numberValue) ? new Date(value) : new Date(String(Math.abs(numberValue)).length === 10 ? numberValue * 1000 : numberValue);
  if (_Number$isNaN(date.getTime())) return String(value);
  return format(date, pattern);
}

function formatDate(value) {
  if (_.isNil(value) || value === '') return '-';
  var numberValue = Number(value);
  var date = _Number$isNaN(numberValue) ? new Date(value) : new Date(String(Math.abs(numberValue)).length === 10 ? numberValue * 1000 : numberValue);
  if (_Number$isNaN(date.getTime())) return String(value);
  return format(date, 'YYYY-MM-DD');
}

function formatAmount(value) {
  var treatZeroAsEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (_.isNil(value) || value === '') return '-';
  var amount = Number(value);
  if (_Number$isNaN(amount)) return String(value);
  if (treatZeroAsEmpty && amount === 0) return '-';
  return amount.toFixed(2);
}

function formatTaxRate(value) {
  if (_.isNil(value) || value === '') return '-';
  var taxRate = Number(value);
  if (_Number$isNaN(taxRate)) return String(value);
  return taxRate + '%';
}

export default {
  name: 'InvoiceManage',
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    InvoiceDialog: InvoiceDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var _this = this;

    return {
      listLoading: false,
      query: _extends({}, defaultQuery),
      pagination: { total: 0 },
      list: [],
      createDialog: { visible: false },
      creatorOptions: [],
      formItemList: [{
        type: 'input',
        prop: 'advance_id',
        params: {
          placeholder: '请输入预收ID'
        }
      }, {
        type: 'input',
        prop: 'customer_name',
        params: {
          placeholder: '请输入客户名称或 ID'
        }
      }, {
        type: 'business',
        subtype: 'advertiser-selector',
        prop: 'adv_id',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          placeholder: '请选择广告主'
        }
      }, {
        type: 'select',
        prop: 'estimate_company_code',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          placeholder: '请选择我方收款主体',
          options: COMPANY_SEARCH_OPTIONS
        }
      }, {
        type: 'input',
        prop: 'manual_invoice_id',
        params: {
          placeholder: '请输入人工票ID'
        }
      }, {
        type: 'select',
        prop: 'created_by',
        params: {
          clearable: true,
          filterable: true,
          remote: true,
          style: 'width: 220px;',
          placeholder: '请选择创建人',
          remoteMethod: function remoteMethod(query) {
            return _this.getCreatorOptions(query);
          },
          handleFocus: function handleFocus() {
            return _this.getCreatorOptions();
          },
          options: []
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          startPlaceholder: '创建开始时间',
          endPlaceholder: '创建结束时间'
        }
      }, {
        type: 'select',
        prop: 'has_refund',
        params: {
          clearable: true,
          placeholder: '是否有退款',
          options: HAS_REFUND_OPTIONS
        }
      }],
      columnConfig: [{ prop: 'id_display', label: 'ID', width: '90px' }, { prop: 'customer_name_display', label: '客户', minWidth: '140px' }, { prop: 'adv_user_display', label: 'Adv User', minWidth: '140px' }, {
        prop: 'estimate_company_name_display',
        label: '我方收款主体',
        minWidth: '180px'
      }, {
        prop: 'traffic_type_display',
        label: '流量类型',
        minWidth: '120px'
      }, { prop: 'advance_id_display', label: '预收ID', minWidth: '120px' }, { prop: 'currency_display', label: '币种', width: '90px' }, {
        prop: 'amount_display',
        label: '开票金额',
        width: '110px'
      }, {
        prop: 'actual_amount_display',
        label: '实收金额',
        width: '110px'
      }, {
        prop: 'receipt_status_display',
        label: '收款状态',
        width: '100px'
      }, {
        prop: 'receipt_date_display',
        label: '收款日期',
        width: '160px'
      }, {
        prop: 'manual_invoice_info',
        label: '人工票',
        slot: 'manual_invoice_info',
        minWidth: '180px'
      }, {
        prop: 'advance_sync_status',
        label: '预收同步状态',
        slot: true,
        width: '130px'
      }, {
        prop: 'failure_reason',
        label: '失败原因',
        slot: true,
        minWidth: '180px'
      }, {
        prop: 'invoice_status',
        label: 'Invoice 状态',
        slot: true,
        width: '110px'
      }, {
        prop: 'invoice_file_url',
        label: 'Invoice 文件',
        slot: true,
        width: '100px'
      }, {
        prop: 'recharge_total_amount_display',
        label: '充值总金额',
        width: '110px'
      }, {
        prop: 'tax_display',
        label: 'tax',
        slot: 'tax_display',
        width: '110px'
      }, { prop: 'recharge_time_display', label: '充值时间', width: '160px' }, {
        prop: 'refund_total_amount_display',
        label: '退款总金额',
        width: '110px'
      }, {
        prop: 'last_refund_time_display',
        label: '最后一次退款时间',
        width: '160px'
      }, {
        prop: 'fail_reason',
        label: '失败原因',
        slot: 'fail_reason',
        minWidth: '180px'
      }, {
        prop: 'remark',
        label: '备注',
        slot: 'remark',
        minWidth: '160px'
      }, {
        prop: 'created_info',
        label: '创建信息',
        slot: 'created_info',
        width: '160px'
      }, {
        prop: 'action-cell',
        label: '操作',
        slot: 'action-cell',
        width: '160px',
        fixed: 'right'
      }]
    };
  },

  watch: {
    $route: function $route(to) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.getList(this.query);
    }
  },
  methods: {
    _cookQuery: function _cookQuery(query) {
      var isNumber = function isNumber(value) {
        return (/^[1-9]+$/.test(value)
        );
      };
      var newQuery = _.omit(_extends({}, query), REMOVED_QUERY_KEYS);

      _.each(newQuery, function (value, key) {
        if (_.isString(value) && isNumber(value)) {
          newQuery[key] = Number(value);
        }

        if (_.isArray(value) && value.every(function (item) {
          return _.isString(item) && isNumber(item);
        })) {
          newQuery[key] = value.map(function (item) {
            return Number(item);
          });
        }
      });

      return newQuery;
    },
    displayText: function displayText(value) {
      return _.isNil(value) || value === '' ? '-' : value;
    },
    advanceSyncStatusLabel: function advanceSyncStatusLabel(status) {
      var statusKey = normalizeStatus(status, ADVANCE_SYNC_STATUS_ALIAS);
      return (ADVANCE_SYNC_STATUS_MAP[statusKey] || {
        label: this.displayText(status)
      }).label;
    },
    advanceSyncStatusTag: function advanceSyncStatusTag(status) {
      var statusKey = normalizeStatus(status, ADVANCE_SYNC_STATUS_ALIAS);
      return (ADVANCE_SYNC_STATUS_MAP[statusKey] || { type: 'info' }).type;
    },
    invoiceStatusLabel: function invoiceStatusLabel(status) {
      var statusKey = normalizeStatus(status, INVOICE_STATUS_ALIAS);
      return (INVOICE_STATUS_MAP[statusKey] || { label: this.displayText(status) }).label;
    },
    invoiceStatusTag: function invoiceStatusTag(status) {
      var statusKey = normalizeStatus(status, INVOICE_STATUS_ALIAS);
      return (INVOICE_STATUS_MAP[statusKey] || { type: 'info' }).type;
    },
    trafficTypeLabel: function trafficTypeLabel(type) {
      return TRAFFIC_TYPE_MAP[type] || this.displayText(type);
    },
    receiptStatusLabel: function receiptStatusLabel(status) {
      if (_.isNil(status) || status === '') return '-';
      return RECEIPT_STATUS_MAP[status] || '-';
    },
    hasTaxRate: function hasTaxRate(row) {
      var taxRate = Number(row.tax_rate);
      return !_Number$isNaN(taxRate) && taxRate > 0;
    },
    resolveRecordId: function resolveRecordId(row) {
      return row.id || row.record_id || row.invoice_id;
    },
    isReceiptDeletable: function isReceiptDeletable(row) {
      var deletableStatus = ['失败', '收款失败', 'failed', 'FAILED', '4'];
      var statusFields = [row.receipt_status, row.receipt_status_display];

      return statusFields.some(function (status) {
        if (_.isNil(status) || status === '') return true;
        var normalizedStatus = String(status).trim();
        if (normalizedStatus === '0') return true;
        return deletableStatus.includes(normalizedStatus);
      });
    },
    canDelete: function canDelete(row) {
      return !!this.resolveRecordId(row) && this.isReceiptDeletable(row);
    },
    isInvoiceReissuable: function isInvoiceReissuable(row) {
      return this.isInvoiceFailed(row);
    },
    isAdvanceSyncFailed: function isAdvanceSyncFailed(row) {
      return normalizeStatus(row.advance_sync_status, ADVANCE_SYNC_STATUS_ALIAS) === 'failed';
    },
    isAdvanceSyncSuccess: function isAdvanceSyncSuccess(row) {
      return normalizeStatus(row.advance_sync_status, ADVANCE_SYNC_STATUS_ALIAS) === 'success';
    },
    isInvoiceFailed: function isInvoiceFailed(row) {
      return normalizeStatus(row.invoice_status, INVOICE_STATUS_ALIAS) === 'failed';
    },
    canDeleteOrRepush: function canDeleteOrRepush(row) {
      return this.isAdvanceSyncFailed(row);
    },
    canReissueInvoice: function canReissueInvoice(row) {
      return !!this.resolveRecordId(row) && this.isInvoiceReissuable(row);
    },
    manualInvoiceId: function manualInvoiceId(row) {
      return row.manual_invoice_id || row.invoice_id;
    },
    hasManualInvoice: function hasManualInvoice(row) {
      var id = Number(this.manualInvoiceId(row));
      return !_Number$isNaN(id) && id > 0;
    },
    manualInvoiceStatus: function manualInvoiceStatus(row) {
      var statusFields = [row.manual_invoice_status, row.manual_invoice_sync_status, row.invoice_status, row.invoice_sync_status, row.sync_status];
      var status = statusFields.find(function (item) {
        return !_.isNil(item) && item !== '';
      });
      if (!_.isNil(status) && status !== '') return status;

      if (this.manualInvoiceFileUrl(row)) return 2;
      if (this.hasManualInvoice(row)) return 1;
      return 0;
    },
    manualInvoiceStatusLabel: function manualInvoiceStatusLabel(row) {
      var statusKey = normalizeStatus(this.manualInvoiceStatus(row), MANUAL_INVOICE_STATUS_ALIAS);
      return (MANUAL_INVOICE_STATUS_MAP[statusKey] || {
        label: this.displayText(this.manualInvoiceStatus(row))
      }).label;
    },
    manualInvoiceFileName: function manualInvoiceFileName(row) {
      var fileName = row.manual_invoice_file_name || row.manual_invoice_filename || row.manual_invoice_pdf_file_name || row.invoice_pdf_file_name || row.pdf_file_name || row.invoice_file_name || row.invoice_filename || row.file_name;
      if (fileName) return fileName;

      return this.fileNameFromUrl(this.manualInvoiceFileUrl(row));
    },
    manualInvoiceFileUrl: function manualInvoiceFileUrl(row) {
      return row.manual_invoice_file_url || row.manual_invoice_pdf_url || row.invoice_pdf_url || row.pdf_url || row.invoice_file_url;
    },
    fileNameFromUrl: function fileNameFromUrl(url) {
      if (!url) return '';
      var urlWithoutQuery = String(url).split('?')[0];
      var fileName = urlWithoutQuery.split('/').pop();
      if (!fileName) return '';

      try {
        return decodeURIComponent(fileName);
      } catch (error) {
        console.error(error);
        return fileName;
      }
    },
    getCreatorOptions: function getCreatorOptions() {
      var _this2 = this;

      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, creatorItem, _creatorItem;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return searchUserList({
                  keyword: keyword,
                  search_field: 'real_name'
                });

              case 3:
                res = _context.sent;

                _this2.creatorOptions = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.real_name
                  });
                });
                creatorItem = _this2.formItemList.find(function (item) {
                  return item.prop === 'created_by';
                });

                if (creatorItem) {
                  creatorItem.params.options = _this2.creatorOptions;
                }
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this2.creatorOptions = [];
                _creatorItem = _this2.formItemList.find(function (item) {
                  return item.prop === 'created_by';
                });

                if (_creatorItem) {
                  _creatorItem.params.options = [];
                }
                console.error(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 9]]);
      }))();
    },
    getList: function getList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.listLoading = true;
                _context2.next = 4;
                return fetchInvoiceList(_this3._cookQuery(_extends({}, params)));

              case 4:
                res = _context2.sent;

                _this3.listLoading = false;

                if (!(res.status !== 200)) {
                  _context2.next = 9;
                  break;
                }

                _this3.$message.error('获取列表失败');
                return _context2.abrupt('return');

              case 9:
                _this3.list = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    id_display: _this3.displayText(item.id),
                    advance_id_display: _this3.displayText(item.advance_id),
                    customer_name_display: _this3.displayText(item.customer_name),
                    adv_user_display: _this3.displayText(item.adv_user || item.adv_user_name || item.adv_name),
                    estimate_company_name_display: _this3.displayText(item.estimate_company_name),
                    traffic_type_display: _this3.trafficTypeLabel(item.traffic_type),
                    currency_display: _this3.displayText(item.currency),
                    amount_display: formatAmount(item.amount, false),
                    actual_amount_display: formatAmount(item.actual_amount, false),
                    receipt_status_display: _this3.receiptStatusLabel(item.receipt_status),
                    receipt_date_display: formatDate(item.receipt_date),
                    manual_invoice_id_display: _this3.displayText(_this3.manualInvoiceId(item)),
                    recharge_total_amount_display: formatAmount(_.isNil(item.recharge_amount) || item.recharge_amount === '' ? item.recharge_total_amount : item.recharge_amount),
                    tax_rate_display: formatTaxRate(item.tax_rate),
                    tax_display: formatAmount(item.tax),
                    recharge_time_display: formatDateTime(_.isNil(item.recharge_time) || item.recharge_time === '' ? item.last_recharge_time : item.recharge_time, 'YYYY-MM-DD HH:mm'),
                    refund_total_amount_display: formatAmount(_.isNil(item.refund_amount) || item.refund_amount === '' ? item.refund_total_amount : item.refund_amount),
                    last_refund_time_display: formatDateTime(item.last_refund_time),
                    created_by_name_display: _this3.displayText(item.created_by_name || item.created_by),
                    created_time_display: formatDateTime(item.created_time)
                  });
                });
                _this3.pagination.total = _.get(res, 'data.data.total') || 0;
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                _this3.listLoading = false;
                console.error(_context2.t0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 13]]);
      }))();
    },
    runRowAction: function runRowAction(_ref) {
      var _this4 = this;

      var row = _ref.row,
          title = _ref.title,
          message = _ref.message,
          requestFn = _ref.requestFn,
          successMessage = _ref.successMessage;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _this4.resolveRecordId(row);

                if (id) {
                  _context4.next = 4;
                  break;
                }

                _this4.$message.error('缺少单据ID，暂时无法执行该操作');
                return _context4.abrupt('return');

              case 4:
                _this4.$confirm(message, title, {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return requestFn({ id: id });

                        case 3:
                          _this4.$message.success(successMessage);
                          _this4.getList(_this4.query);
                          _context3.next = 10;
                          break;

                        case 7:
                          _context3.prev = 7;
                          _context3.t0 = _context3['catch'](0);

                          console.error(_context3.t0);

                        case 10:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this4, [[0, 7]]);
                }))).catch(function () {});

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleDelete: function handleDelete(row) {
      var id = this.resolveRecordId(row);
      this.runRowAction({
        row: row,
        title: '删除单据',
        message: '\u786E\u8BA4\u5220\u9664\u8BB0\u5F55 ID\uFF1A' + this.displayText(id) + ' \u7684\u5355\u636E\u5417\uFF1F',
        requestFn: deleteInvoice,
        successMessage: '删除成功'
      });
    },
    handleRepush: function handleRepush(row) {
      this.runRowAction({
        row: row,
        title: '重新推送',
        message: '确认重新推送该预收单据吗？',
        requestFn: retryPushInvoice,
        successMessage: '重新推送成功'
      });
    },
    handleReissue: function handleReissue(row) {
      var id = this.resolveRecordId(row);
      this.runRowAction({
        row: row,
        title: '重新开票',
        message: '\u786E\u8BA4\u91CD\u5F00\u8BB0\u5F55 ID\uFF1A' + this.displayText(id) + ' \u7684\u53D1\u7968\u5417\uFF1F',
        requestFn: reissueInvoice,
        successMessage: '重新开票成功'
      });
    },
    handleReload: function handleReload() {
      this.getList(this.query);
    },
    showCreateDialog: function showCreateDialog() {
      this.createDialog.visible = true;
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.getList(this.query);
    }
  },
  mounted: function mounted() {
    this.getList(this.query);
  }
};